// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text, TextProps } from '@mantine/core';
import { FC } from 'react';

interface Props extends TextProps {
  onClick: () => void;
}

const LinkText: FC<Props> = ({ children, ...rest }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Text color="blue" variant="link" sx={{ cursor: 'pointer', display: 'inline-block' }} {...rest}>
    {children}
  </Text>
);

export default LinkText;
